import { useEffect, useState } from "react";
import GetIcon from "../../../../utils/Icon";
import Tab1 from "./Tab1";
import Table from "./Table";
import { usePostItemListMutation } from "../../../../store/api/purchaseorderapi";
import { useGetSelectedCompanyQuery } from '../../../../store/api/companyapi'
import ApiResponseBox from "../../../../Components/ApiResponseBox";
import Button from "../../../../Core/Button/Button";
import FormLayout from "../../../../Core/Layout/FormLayout";
import { useGetWorkOrderDetailQuery, usePostAssemblyPickListMutation, usePostCreateAssemblyMutation, usePostSubmitAssemblyMutation } from "../../../../store/api/assemblyapi";
import OperationLeft from "./Operations/OperationLeft";
import OperationRight from "./Operations/OperationRight";
import { useLocation, useNavigate } from "react-router-dom";

const AssemblyForm = () => {
  const nvg = useNavigate()
  const [tab, settab] = useState(1)
  const [podate, setpodate] = useState(new Date().toISOString().split('T')[0])
  const [error, setError] = useState('');
  const [ptype, setptype] = useState("Error")
  const [finalstep, setfinalstep] = useState(false);
  const [showError, setShowError] = useState(false);
  const [po_response, setpo_response] = useState("");
  const [selectWOItem, setselectWOItem] = useState(""); 
  const [selectWOBOM, setselectWOBOM] = useState(""); 
  const [fulldata, setfulldata] = useState({}); 
  const [QtyToManufacture, setQtyToManufacture] = useState(''); 
  const [requiredItem, setrequiredItem] = useState([]); 
  const [operation, setoperation] = useState([]); 
  const [selected_item_data, setselected_item_data] = useState([]);
  const [fieldErrors, setFieldErrors] = useState({
    WOItem: false,
    WOBOM: false,
    QTY: false,
    items: false
  });
  const [getitem_list_data] = usePostItemListMutation();
  const [createpicklist] = usePostAssemblyPickListMutation()
  const { data } = useGetSelectedCompanyQuery();
  const location = useLocation();
  console.log("location",location)
  const { data:WODetail,isLoading:Detail_Loader } = useGetWorkOrderDetailQuery(location.state);
  console.log("check wodetail data",WODetail);
  useEffect(()=>{
   if(!Detail_Loader){
    setpodate(WODetail?.data?.creation.split(' ')[0]);
    setselectWOItem(WODetail?.data?.item_name);
    setselectWOBOM(WODetail?.data?.bom_no);
    setQtyToManufacture(WODetail?.data?.qty);
    setrequiredItem(WODetail?.data?.required_items);
    setoperation(WODetail?.data?.operations);
    setfulldata(WODetail.data);
    console.log("sdfg",WODetail)
   }
  },[WODetail,Detail_Loader])
  const selectcompany = data?.message?.data?.company; 
  const [createApi] = usePostSubmitAssemblyMutation() 

  const validateForm = () => {
    const errors = {
      WOItem: !selectWOItem,
      WOBOM: !selectWOBOM,
      QTY: !QtyToManufacture || isNaN(QtyToManufacture) || Number(QtyToManufacture) <= 0,
    };
    
    setFieldErrors(errors);
    return !Object.values(errors).some(error => error);
  };

  const SubmitPurchaseOrder = async () => {


    try {
      const payload = {work_order_name: location.state };

      const response = await createApi(payload).unwrap();
      
      setpo_response(response);
      setptype('Success');
      setError('Work Order created successfully!');
      setShowError(true);
      setfinalstep(true);
    } catch (err) {
      setptype('Error');
      setError(err.data?.message || 'Failed to create Work Order');
      setShowError(true);
    }
  }

   const getPickID = async() =>{
           try {
            const response = await createpicklist({"source_name": location.state,"for_qty": QtyToManufacture});
            console.log("api respinse is hee",response.data.message.data.name)
            nvg("/assmbly/create-pick",{state:response.data.message.data.name})
            
           } catch (error) {
            console.log("check error",error)
           }
       } 

  const CreatePurchaseOrder = () =>{}

  return (
    <FormLayout
      title="New Work Order"
      breadcrumbs={[
        { label: "Work Order" },
        { label: "Work Order List", url: "/assmbly/assembly-list" }
      ]}
      status={'Draft'}
      finalStep={finalstep}
      actionButtons={
        <>
         <Button
            className="custom-btn-00989"
            onClick={SubmitPurchaseOrder}
            iconName="LuFilePlus2"
            style={{ gap: '2px', height: '28px' }}
            iconSize={12}
            display={finalstep ? 'none' : 'flex'}
          >
            Submit
          </Button>
     
          <Button
                      onClick={getPickID}
                      // to="/assmbly/create-pick"
                      style={{ backgroundColor: '#fff', height: '28px' }}
                      className="custom-btn-00989blue"
                      display={finalstep ? "flex" : "none"}
                    >
                      Create Pick
                    </Button>

         
        </>
      }
    >
      <div className="d-flex flex-column" style={{ width: "100%", backgroundColor: "#fff",flexGrow:'1' }}>
        <div className="col-12 p-0" style={{ backgroundColor: '#eff4f9' }}>
          <div className="d-flex justify-content-between align-items-end ">

            <ul className="nav nav-tabs" style={{ color: "white", border: "none" }}>
              <li className="nav-item-tab-custom d-flex pb-0 align-items-end border-radius-top-corner" >
                <a className={tab == 1 ? "removeborder234 nav-link active-tab-custom text-white border-radius-top-corner" : "removeborder234 nav-link nav-link-tab-custom bg-white border-radius-top-corner"} onClick={() => { settab(1) }} href="javascript:void(0);">
                  Production Item{tab == 1 ? <GetIcon iconName="MdKeyboardArrowDown" size={15} /> : <GetIcon iconName="MdKeyboardArrowRight" size={15} />}
                </a>
              </li>
             {operation.length > 0 && <li className="nav-item-tab-custom pb-0 d-flex align-items-end border-radius-top-corner"  >
                              <a className={tab == 2 ? "removeborder234 nav-link active-tab-custom text-white border-radius-top-corner" : "removeborder234 nav-link nav-link-tab-custom bg-white border-radius-top-corner"} onClick={() => { settab(2) }} href="javascript:void(0);">
                                Operations {tab == 2 ? <GetIcon iconName="MdKeyboardArrowDown" size={15} /> : <GetIcon iconName="MdKeyboardArrowRight" size={15} />}
                              </a>
                            </li>} 
            </ul>

            <div className="d-flex align-items-center mb-2 px-3" style={{ gap: "2px", fontSize: '12px' }}>
              <span style={{ position: 'relative', top: '-1px' }}>
                <GetIcon iconName="CgAttachment" size={12} />
              </span>
              <span className=" fw-semibold" style={{ color: "#391F84" }}>
                Attachments
              </span>
            </div>

          </div>
        </div>

        <div className="row d-flex justify-content-between" style={{marginTop: tab == 1 ? '14px' : '0',visibility: tab == 1 ? "visible" : 'hidden',height: tab == 1 ? "auto" : '0px',overflow:'hidden',flexGrow:'1' }}>
          <div className="col-3 " style={{ visibility: tab == 1 ? "visible" : 'hidden', height: tab == 1 ? "auto" : '0px' }}>
            <Tab1 
            WOI={{setselectWOItem, selectWOItem, Error: fieldErrors.WOItem }}
             WOBOM={{setselectWOBOM, selectWOBOM, Error: fieldErrors.WOBOM }}
             qty={{setQtyToManufacture, QtyToManufacture, Error: fieldErrors.QTY }}
             podate={{ podate, setpodate }} ponumber={'MFG-WO-2025-00001'}
              />
          </div>
          <div className="col-9 d-flex flex-column mt-2" style={{ visibility: tab == 1 ? "visible" : 'hidden', height: tab == 1 ? "auto" : '0px', minHeight: tab == 1 ? '440px' : '0' }}>
            <div className="d-flex pb-2" style={{ gap: '5px' }}>
              <p className="NoOfLine">No. of lines - <span style={{ color: '#2563EB' }}> {requiredItem.length}</span></p>
              <p className="TotalQty">Total Quantity -  <span style={{ color: '#16A34A' }}> {requiredItem.reduce((total, item) => { return total + Number(item.required_qty); }, 0)}</span></p>
            </div>
            <div className="tableLabel">
              <div style={{ width: '98.5%', borderBottom: '1px solid #caced3', marginBottom: '6px' }}></div>
              <p className="" style={{ color: "#1E1E1E", fontWeight: '500', marginBottom: '4px',fontSize:'15px' }}>
                Required Items
              </p>
            </div>
            <Table TB_data={requiredItem} />
           
          </div>
          
        </div>


        <div className="row d-flex justify-content-between" style={{marginTop: tab == 2 ? '14px' : '0',visibility: tab == 2 ? "visible" : 'hidden',height: tab == 2 ? "auto" : '0px',overflow:'hidden' }}>
                  <div className="col-3 ">
                    <OperationLeft
                     TMA={{ setTMA:{},TMA:fulldata?.transfer_material_against, Error: fieldErrors.TMA }}
                     checkbox={{withOperations:"",setwithOperations:{}}}
                     />
                  </div>
                  <div className="col-9 d-flex flex-column mt-1">
                    <div className="tableLabel">
                      <p className="" style={{ color: "#1E1E1E", fontWeight: '500', marginBottom: '4px' }}>
                        Operations
                      </p>
                    </div>
                    <OperationRight TB_data={operation} />
                  </div>
                </div>
      </div>
      <ApiResponseBox
        poptype={ptype}
        show={showError}
        errorMessage={error}
        onClose={() => setShowError(false)}
      />
    </FormLayout>
  );
};

export default AssemblyForm;